class AmountFormatter {

    constructor(options = null) {
        this.INPUT_CLASS_NAME = 'amount-format';
        this.INPUT_CLASS_NAME_WITH_DECIMAL = 'amount-format-with-decimal';
        this.LOCALES = 'ja-JP';
        if(options) {
            for(let k in options) {
                if(k === 'inputClassName') {
                    this.INPUT_CLASS_NAME = options[k];
                } else if(k === 'inputClassNameWithDecimal') {
                    this.INPUT_CLASS_NAME_WITH_DECIMAL = options[k];
                } else if(k === 'locales') {
                    this.LOCALES = options[k];
                }
            }
        }
    }


    format(input) {
        if(input == null || input.value === '') {
            return;
        }
        const num = parseFloat(input.value.replace(/,/g, ''));
        input.value = (Math.round(num*100) / 100).toLocaleString(this.LOCALES);
    }


    handleInputEvent(e) {
        const withDecimalFlag = e.target.classList.contains(this.INPUT_CLASS_NAME_WITH_DECIMAL);
        let replaced;
        if(withDecimalFlag) {
            if(e.data === '.' ||
                    e.data === ',' ||
                    e.target.value.length > 0 && e.target.value[e.target.value.length-1] === '.' ||
                    e.target.value.length > 1 && e.target.value[e.target.value.length-2] === '.' && e.target.value[e.target.value.length-1] === '0' && e.data === '0') {
                return;
            }
            let i = 0;
            replaced = e.target.value
                    .replace(/[０-９]/g, (s) => {
                      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                    })
                    .replace(/[^0-9,\.]/g, '')
                    .replace(/\.+/g, (v) => {
                        if(i++ === 0) {
                            return v;
                        } else {
                            return '';
                        }
                    });
        } else {
            if(e.data === ',') {
                return;
            }
            replaced = e.target.value
                .replace(/[０-９]/g, (s) => {
                      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                    })
                .replace(/[^0-9,]/g, '');
        }
        e.target.value = replaced;
        this.format(e.target);
    }


    handleSubmitEvent(forms) {
        if(forms == null || forms.length === 0) {
            return;
        }
        for(let i = 0; i < forms.length; i++) {
            forms[i].addEventListener('submit', (e) => {
                let inputs = e.target.querySelectorAll('.' + this.INPUT_CLASS_NAME + ',.' + this.INPUT_CLASS_NAME_WITH_DECIMAL);
                if(inputs != null && inputs.length > 0) {
                    for(let j = 0; j < inputs.length; j++) {
                        inputs[j].value = inputs[j].value.replace(/,/g, '');
                    }
                }
            }, false);
        }
    }


    setUp(inputs) {
        const forms = new Array();
        for(let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            input.type = 'text';
            this.format(input);
            input.addEventListener('change', (e) => { this.handleInputEvent(e); }, false);
            if(input.form != null) {
                const finded = forms.findIndex(f => f.dataset.amountFormatter.toString() === '1');
                if(finded === -1) {
                    input.form.dataset.amountFormatter = '1';
                    forms.push(input.form);
                }
            }
        }
        this.handleSubmitEvent(forms);
    }


    setUpWithoutDecimal() {
        const inputs = document.getElementsByClassName(this.INPUT_CLASS_NAME);
        if(inputs == null || inputs.length === 0) {
            return;
        }
        this.setUp(inputs);
    }


    setUpWithDecimal() {
        const inputs = document.getElementsByClassName(this.INPUT_CLASS_NAME_WITH_DECIMAL);
        if(inputs == null || inputs.length === 0) {
            return;
        }
        this.setUp(inputs);
    }


    AddInput(input) {
        this.setUp([input]);
    }


    Run() {
        this.setUpWithoutDecimal();
        this.setUpWithDecimal();
    }

}
export { AmountFormatter as default }
